import * as React from 'react';
import { SVGProps } from 'react';

const SvgPodcast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m17.31 22.84 5.23 12.62m-5.23-12.62-5.75 12.62"
    />
    <path fill={props.fill} d="M34.08 38.58H9.07v-5h19.98l5.03 5Z" />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m25.25 25.43-3.07 3.11a7.502 7.502 0 1 1-10.61-10.61l3.09-3.09 10.59 10.59Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m25.27 25.45 7.99-7.99A7.502 7.502 0 1 0 22.65 6.85l-7.99 7.99"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M17.31 26.54a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
    />
    <path
      fill="currentColor"
      d="M17.3 23.73a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6Zm1.45-8.93a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6-2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm0 5.2a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6-2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm0 5.2a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6-2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm0 5.2a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6-2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm-5.2-10.4a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6 2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6 2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6 2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46ZM26.64 6.91a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6 2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.6 2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Zm2.59 2.6a1.23 1.23 0 1 0 0-2.46 1.23 1.23 0 0 0 0 2.46Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M11.28 8.27 8.63 5.62m-.01 7.07L5 11.72m10.7-6.1L14.72 2"
    />
  </svg>
);

export default SvgPodcast;
